import moment from 'moment';

const getters = {
  hasFiltersApplied: state => Object.values(state.filters).filter(Boolean).length > 0,

  filtersApplied: state => Object.values(state.filters),

  tutorId: (state, gttrs, rootState, rootGetters) =>
    rootGetters.userProfile && rootGetters.userProfile.tutor_id ? rootGetters.userProfile.tutor_id : null,

  tutorEmail: (state, gttrs, rootState, rootGetters) =>
    rootGetters.userProfile && rootGetters.userProfile.tutor_hashed_email
      ? rootGetters.userProfile.tutor_hashed_email
      : null,

  visibleColumns: state => state.columns.filter(column => column.showColumn),

  nearestAvailableClass: (state, gttrs, rootState, rootGetters) => {
    return (
      state.nearestClasses.find(nearestClass => {
        if (nearestClass.canceled_at) {
          return false;
        }
        const startOfJoiningWindow = new Date(nearestClass.join_time_min);
        const endOfJoiningWindow = new Date(nearestClass.join_time_max);
        const endOfShowBannerRange = moment(endOfJoiningWindow).add(5, 'minutes').toDate();
        return rootGetters.now >= startOfJoiningWindow && rootGetters.now <= endOfShowBannerRange;
      }) || null
    );
  },

  ongoingClass: (state, gttrs, rootState, rootGetters) => {
    return (
      state.nearestClasses.find(nearestClass => {
        if (nearestClass.canceled_at) {
          return false;
        }
        return rootGetters.now >= new Date(nearestClass.start) && rootGetters.now <= new Date(nearestClass.end);
      }) || null
    );
  },
};

export default getters;
